import { render, staticRenderFns } from "./LabsSelector.vue?vue&type=template&id=61f8b56f&scoped=true&"
import script from "./LabsSelector.vue?vue&type=script&lang=js&"
export * from "./LabsSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabsSelector.vue?vue&type=style&index=0&id=61f8b56f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8b56f",
  null
  
)

export default component.exports